export default {
  MIN_CHARS_TO_AUTOCOMPLETE_RESULTS: 1,
  MAX_AUTO_COMPLETE_RESULTS: Infinity,
  DEBOUNCE_TIME: 300,
  HIGHLIGHT_MATCHED_WORDS: true,
  SHOW_LOADING_ICON: true,
  FETCH_ON_FOCUS: false,
  DEFAULT_PLACEHOLDER: '',
  DEFAULT_TEST_ID: '',
  EMPTY_RESULTS_ON_EMPTY_QUERY: true,
  HIGHLIGHT_RESULTS: true,
  NO_RESULTS_MESSAGE: 'No results found',
  SHOW_NO_RESULTS_MESSAGE: true,
  DISPLAY_KEY: 'title',
  SEARCH_KEYS: [],
  USE_CATEGORIES: false,
};
